/**
 * La réceptionniste IA choisie sur le site (callizy.ca) avant l'inscription.
 *
 * Le choix traverse l'inscription, la vérification du courriel et
 * l'onboarding par un cookie posé sur `.callizy.ca`, lisible ici
 * (app.callizy.ca). En local, le cookie reste sur l'hôte courant.
 */
const NOM = 'callizy_receptionist'

export interface Receptionniste {
  slug: 'pack_m' | 'pack_l' | 'pack_xl'
  name: string
  nameEn: string
  minutes: number
  /** Par mois, avec un forfait mensuel. */
  priceCad: number
  /** Par an, avec un forfait annuel : 12 mois moins 20 % (2 nov. 2026). */
  priceYearlyCad: number
}

export const RECEPTIONNISTES: Record<Receptionniste['slug'], Receptionniste> = {
  pack_m: { slug: 'pack_m', name: 'Réceptionniste Essentiel', nameEn: 'Receptionist Essential', minutes: 150, priceCad: 49, priceYearlyCad: 470.4 },
  pack_l: { slug: 'pack_l', name: 'Réceptionniste Professionnel', nameEn: 'Receptionist Professional', minutes: 350, priceCad: 99, priceYearlyCad: 950.4 },
  pack_xl: { slug: 'pack_xl', name: 'Réceptionniste Entreprise', nameEn: 'Receptionist Enterprise', minutes: 1000, priceCad: 249, priceYearlyCad: 2390.4 },
}

export function nomReceptionniste(r: Receptionniste, langue: string): string {
  return langue.startsWith('en') ? r.nameEn : r.name
}

/** Un montant sans le signe : « 49 », « 470,40 » ou « 470.40 » selon la langue. */
export function montantCad(montant: number, langue: string): string {
  const entier = Number.isInteger(montant)
  return montant.toLocaleString(langue.startsWith('en') ? 'en-CA' : 'fr-CA', {
    minimumFractionDigits: entier ? 0 : 2,
    maximumFractionDigits: 2,
  })
}

function estSlug(v: string | null | undefined): v is Receptionniste['slug'] {
  return !!v && v in RECEPTIONNISTES
}

function domaine(): string {
  return window.location.hostname.endsWith('callizy.ca') ? '; domain=.callizy.ca' : ''
}

export function lireReceptionniste(): Receptionniste | null {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${NOM}=([^;]*)`))
    const slug = m ? decodeURIComponent(m[1]) : null
    return estSlug(slug) ? RECEPTIONNISTES[slug] : null
  } catch {
    return null
  }
}

export function poserReceptionniste(slug: string): void {
  if (!estSlug(slug)) return
  try {
    document.cookie = `${NOM}=${slug}; path=/; max-age=${30 * 24 * 3600}; samesite=lax${domaine()}`
  } catch {
    /* navigation privée, cookies bloqués : le choix se refera dans Facturation */
  }
}

export function effacerReceptionniste(): void {
  try {
    document.cookie = `${NOM}=; path=/; max-age=0${domaine()}`
  } catch {
    /* rien */
  }
}
